
import Vue from 'vue'

export default Vue.extend({
  props: {
    value: Boolean,
  },
  methods: {
    cancelConfirmCancelEdit() {
      this.$emit('input', false)
      this.$emit('cancel')
    },
    confirmConfirmCancelEdit() {
      this.cancelConfirmCancelEdit()
      this.$emit('confirm')
    },
    save() {
      this.cancelConfirmCancelEdit()
      this.$emit('save')
    },
  },
})
